import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ArrowRight } from 'lucide-react';

const BackToDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getNextTab = () => {
    switch (location.pathname) {
      case '/speed':
        return '/pitch';
      case '/pitch':
        return '/contact';
      case '/contact':
        return '/settings';
      default:
        return '/';
    }
  };

  const getNextTabName = () => {
    switch (location.pathname) {
      case '/speed':
        return 'ピッチ&ストライド分析';
      case '/pitch':
        return '接地&滞空分析';
      case '/contact':
        return 'データ管理';
      default:
        return '';
    }
  };

  const showNextButton = ['/speed', '/pitch', '/contact'].includes(location.pathname);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between gap-4">
          <button
            onClick={() => navigate('/')}
            className="flex-1 btn btn-primary py-3 text-lg"
          >
            <Home className="w-5 h-5 mr-2" />
            ダッシュボードに戻る
          </button>
          
          {showNextButton && (
            <button
              onClick={() => navigate(getNextTab())}
              className="flex-1 btn py-3 text-lg bg-green-600 text-white hover:bg-green-700 active:bg-green-800"
            >
              <span className="mr-2">{getNextTabName()}</span>
              <ArrowRight className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BackToDashboard;